<template>
    <div v-if="loading_rg === true">
      <loading />
    </div>
    <div v-else>
      <div class="col s12 m12 no-padding doc-type-section">
      <div class="input-field col s12 m6">
          <input v-model="identidade.pf_rg" type="text" v-bind:class="{'invalid': error_fields['pf_rg']}" id="pf_rg" ref="pf_rg">
          <label for="pf_rg">Número</label>
          <span v-if="error_fields['pf_rg']" class="helper-text" data-error="Este campo deve ser preenchido"></span>
      </div>
      <div class="input-field col s12 m6">
          <input v-model="identidade.pf_rg_emissao" v-mask="['##/##/####']" id="pf_rg_emissao" ref="pf_rg_emissao" type="text" v-bind:class="{'invalid': error_fields['pf_rg_emissao']}">
          <label for="pf_rg_emissao">Data de Emissão</label>
          <span v-if="error_fields['pf_rg_emissao']" class="helper-text" data-error="Este campo deve ser preenchido"></span>
      </div>
      <div class="input-field col s12 m6">
          <select v-model="identidade.pf_rg_ent_classe_meta" v-bind:class="{'invalid': error_fields['pf_rg_ent_classe_meta']}" id="pf_rg_ent_classe_meta" ref="pf_rg_ent_classe_meta">
          <option v-bind:value="null" selected>Selecione</option>
          <option v-for="(orgao, i) in meta.rg_orgao_emissor" v-bind:key="i" v-bind:value="i">{{ orgao }}</option>
          </select>
          <label for="pf_rg_ent_classe_meta">Órgão Emissor</label>
          <span v-if="error_fields['pf_rg_ent_classe_meta']" class="helper-text" data-error="Este campo deve ser preenchido"></span>
      </div>
      <div class="input-field col s12 m6">
          <select v-model="identidade.pf_rg_uf" v-bind:class="{'invalid': error_fields['pf_rg_uf']}" id="pf_rg_uf" ref="pf_rg_uf">
          <option v-bind:value="null" selected>Selecione</option>
          <option v-for="(uf, i) in meta.uf" v-bind:key="i" v-bind:value="i">{{ uf }}</option>
          </select>
          <label for="pf_rg_uf">UF</label>
          <span v-if="error_fields['pf_rg_uf']" class="helper-text" data-error="Este campo deve ser preenchido"></span>
      </div>
      <div class="input-field col s12 m12">
        <button @click="prepareSubmitIdentidade" v-bind:disabled="verificaForm === false" class="btn right" type="button">SALVAR</button>
      </div>
      </div>
    </div>
</template>

<script>
import axios from 'axios'
import Loading from '@/components/Loading.vue'
import {converteData, formataData, verificaData} from '@/assets/js/form-utils.js'
import {CONFIG} from '@/config/config.js'
import SocialService from '@/services/social-service.js'
import sha1 from 'js-sha1'

let socialService = new SocialService(CONFIG.URL_SOCIAL_API_V2)

export default {
  name: 'Identidade',
  components: {
    'loading': Loading,
  },
  props: {
      doc: Object,
      pf_id: String
  },
  data (){
    return {
      loading_rg: false,
      meta: this.$store.state.meta.data,
      identidade: {
        pf_rg: this.doc.identidade,
        pf_rg_emissao: (verificaData(this.doc.emissao, 'YYYY-MM-DD') === true ? converteData(this.doc.emissao) : null),
        pf_rg_uf: this.doc.uf,
        pf_rg_ent_classe_meta: this.doc.emissor,
      },
      error_fields: {},
      loaded: null,
    }
  },
  computed: {
    verificaForm: function () {
        let status = (
            Object.keys(this.identidade).filter((k) => this.identidade[k] && this.identidade[k] != '').length === 4 
            && 
            verificaData(this.identidade.pf_rg_emissao) === true
        )
        this.$emit('statusChange', {
          doc: 1,
          status: status
        })
        return status
    }
  },
  methods: {
    veriifcaDoc(){
      return this.verificaForm
    },
    async submitInsertIdentidade(identidade){
      axios.post(`${CONFIG.URL_SOCIAL_API_V2}/v1/pessoa-fisica/identidade/`, {
        ...identidade,
        ...{
          'pf_id': this.pf_id,
          'device': await socialService.getDeviceInfo()
        }
      })
      .then((response) => {
        this.loading_rg = false
        setTimeout(() => {
          this.initFields()
          this.$emit('docSaved', 0)
        }, 100)
      })
      .catch((error) => {
        M.toast({html: 'Não foi possível realizar esta operação...verifique a sua conexão com a internet e tente novamente!'})
        this.loading_rg = false
        setTimeout(() => {
          this.initFields()
        }, 100)
      })
    },
    prepareSubmitIdentidade(){
      this.loading_rg = true
      let a = this.identidade //Atual

      let identidade = {
        pf_rg: a.pf_rg,
        pf_rg_emissao: formataData(a.pf_rg_emissao),
        pf_rg_uf: a.pf_rg_uf,
        pf_rg_ent_classe_meta: a.pf_rg_ent_classe_meta
      }
      if(this.loaded !== sha1(JSON.stringify(identidade))){
        return this.submitInsertIdentidade(identidade)
      } else {
        this.loading_rg = false
        this.$emit('docSaved', 0)
      }
    },
    initFields () {
      M.updateTextFields()
      M.FormSelect.init(document.querySelectorAll('select'))
    },
    verificaStatusDocumento(){
      let keys = [
        'pf_rg', 'pf_rg_emissao'
      ]

      let selectKeys = [
        'pf_rg_ent_classe_meta', 'pf_rg_uf'
      ]

      let status = true //Até que se prove o contrário
      keys.forEach((key) => {
        if(this.identidade[key] == null || this.identidade[key] == ''){
          status = false
          this.$set(this.error_fields, key, true)
        } else {
          this.$set(this.error_fields, key, false)
        }
      })

      selectKeys.forEach((sKey) => {
        if(this.identidade[sKey] == null || this.identidade[sKey] == ''){
          status = false
          M.FormSelect.getInstance(this.$refs[sKey]).wrapper.classList.add('invalid')
        } else {
          M.FormSelect.getInstance(this.$refs[sKey]).wrapper.classList.remove('invalid')
        }
      })
    }
  },
  watch: {
    identidade: {
      handler: function(updated_perfil, old_perfil){
        setTimeout(() => {
          this.changed = true
          this.step_completed = this.verificaStatusDocumento()
        }, 300)
      },
      deep: true
    }
  },
  mounted(){
    this.loaded = sha1(JSON.stringify({
      pf_rg: this.identidade.pf_rg,
      pf_rg_emissao: (verificaData(this.identidade.pf_rg_emissao, 'YYYY-MM-DD') === true ? formataData(this.identidade.pf_rg_emissao) : null),
      pf_rg_uf: this.identidade.pf_rg_uf,
      pf_rg_ent_classe_meta: this.identidade.pf_rg_ent_classe_meta
    }))
    this.initFields()
  }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/steps/documentos/Identidade.vue